import { Injectable } from '@angular/core';
import {ApiService} from '@abstract/api.service';

@Injectable()
export class LabsApiService extends ApiService {
    protected baseUrl = 'laboratory';

    public responsibleStaffUrl = this.baseUrl + '/responsible-staff';
    public responsibleStaffTypesUrl = 'responsible-staff/types'; // чтобы не делать отдельное API
}
